import React from 'react';
import { InitialsBadge } from '@/components/InitialsBadge';
import styles from './AvatarStack.module.scss';

export const AvatarStack = ({ members = [], max = 4 }) => {
  const visible = members.slice(0, max);
  const overflowCount = members.length - visible.length;

  return (
    <div className={styles.stack}>
      {visible.map((name, index) => (
        <div
          key={`${name}-${index}`}
          className={styles.avatarWrap}
          style={{ zIndex: visible.length - index }}
        >
          <InitialsBadge label={name} twoLetter />
        </div>
      ))}
      {overflowCount > 0 && (
        <div className={styles.avatarWrap} style={{ zIndex: 0 }}>
          <span className={styles.overflowBadge}>+{overflowCount}</span>
        </div>
      )}
    </div>
  );
};

AvatarStack.displayName = 'AvatarStack';
